import { gql } from "@apollo/client";

export const AI_BRAIN_FRAGMENT = gql`
  fragment AiBrainFields on UserBrainNode {
    id
    consolidated
    liveNotes
    lastDreamAt
    lastLiveUpdateAt
    updated
  }
`;

export const GET_AI_BRAIN = gql`
  query GetAiBrain {
    me {
      aiBrain {
        ...AiBrainFields
      }
    }
  }
  ${AI_BRAIN_FRAGMENT}
`;

export const UPDATE_AI_BRAIN_CONSOLIDATED = gql`
  mutation updateAiBrain($content: String!) {
    updateAiBrainConsolidated(content: $content) {
      aiBrain {
        ...AiBrainFields
      }
    }
  }
  ${AI_BRAIN_FRAGMENT}
`;

export const REFRESH_AI_BRAIN = gql`
  mutation refreshAiBrainMemory {
    refreshAiBrain {
      aiBrain {
        ...AiBrainFields
      }
    }
  }
  ${AI_BRAIN_FRAGMENT}
`;
